import {Component, Input, OnInit} from '@angular/core';
import {VariableDataBase} from "../../../variableDataBase/variable-data-base.service";
import {ActivatedRoute, Router} from "@angular/router";

@Component({
  selector: 'app-irrigation-valve-card-link',
  templateUrl: './irrigation-valve-card-link.component.html',
  styleUrls: ['./irrigation-valve-card-link.component.css']
})
export class IrrigationValveCardLinkComponent implements OnInit {
  @Input() filelinkBack: number = 0;
  @Input() departmentClass: string = "json-department-card";

  constructor(
    private route: ActivatedRoute,
    private router: Router  ) {}

  ngOnInit(): void {

  }

  counter(i: number) {
    return new Array(i);
  }

  Home() {
    this.router.navigate(['/cards', {filelink: 9999}]);
  }

  ZoomInCard(filelink: number) {
    console.log("ROUTING");
    this.router.navigate(['/valveoverview', { filelink: filelink }]);
  }
}
